import { computedToken } from "@planningcenter/tapestry"

export default {
  activeColor: window.isPhoenix
    ? computedToken("--t-fill-color-control-primary")
    : computedToken("--t-fill-color-product-people-050"),
}
